
import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {UIGamePlayerInformationLongestRoadController} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationLongestRoadController'
import {UIWGamePlayerInformationLongestRoadView} from './UIWGamePlayerInformationLongestRoadView'

export class UIWGamePlayerInformationLongestRoadController extends UIGamePlayerInformationLongestRoadController {
    protected createLongestRoadView(playerState: PlayerValidator) {
        return new UIWGamePlayerInformationLongestRoadView(this.uiGameManager, playerState)
    }
}
